<template>
    <div class="adBox">
        <div>
            <van-swipe :loop="true" :autoplay="5000" duration="1000">
                <van-swipe-item v-if="$root.adList && $root.adList.indexRotationAd" v-for="item in $root.adList.indexRotationAd" :key="item.id">
                    <a :href="item.url" target="_blank">
                        <van-image
                                class="indexRotationAdImg"
                                lazy-load
                                :src="item.imgUrl"
                        >
                            <template v-slot:error>图片飞走了..</template>
                        </van-image>
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "indexRotationAd",
    }
</script>

<style scoped>

</style>